// extracted by mini-css-extract-plugin
export var hidden = "_se-0";